import script from "./goRinSyo0044.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0044.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0044.vue?vue&type=style&index=0&id=2c9ad0fc&lang=scss"

const __exports__ = script;

export default __exports__